<template>
  <!--投诉建议 -->
  <div class="layout">
    <Layout>
      <!-- 头 -->
      <Header>
        <Menu theme="light" mode="horizontal" active-name="2-1">
          <div class="layout-logo">
            <a href="/"> <img src="../assets/logo-title-v3.png" alt="" /></a>
          </div>
          <div class="layout-nav">
            <!-- <MenuItem style="font-size: 18px !important" name="1" to="/sourceInformation">
            aa信息
            </MenuItem>
            <MenuItem to="/vehicleInformation" style="font-size: 18px !important" name="2">
            bb信息
            </MenuItem> -->
            <MenuItem to="/complaintPublicity" style="font-size: 18px !important" name="3">
            评价公示
            </MenuItem>
            <MenuItem to="/evaluationPublicity" style="font-size: 18px !important" name="4">
            投诉公示
            </MenuItem>
            <Submenu name="5">
              <template slot="title"><span style="font-size: 18px !important">联系客服</span>
              </template>
              <MenuItem to="/customerServiceContact" style="
                  font-size: 15px !important;
                  padding-left: 35px !important;
                " name="2-1">投诉建议</MenuItem>
              <MenuItem to="/contactUs" style="
                  font-size: 15px !important;
                  padding-left: 35px !important;
                " name="2-2">联系我们</MenuItem>
            </Submenu>
          </div>
        </Menu>
      </Header>
      <div class="Header-img">
        <div class="main-content">
          <span class="title-img">投诉建议</span>
          <p class="memo">您好，感谢您对拼卡卡的关注与支持</p>
        </div>
      </div>
      <!-- 中 -->
      <Content>
        <div class="main1">
          <div style="display: flex; justify-content: center">
            <div>
              <div>
                <div></div>
                <div>
                  <div>
                    <span
                      style="color: #666666; font-size: 16px">如果您对我们的工作和服务有任何意见、建议，请填写以下内容进行反馈，您的反馈对我们非常重要。为了使您的反馈得到及时回复和处理，请您完整填写以下信息。</span>
                    <!-- <p style="color: #f88b49; font-size: 16px; margin-top: 8px">
                      谢谢！
                    </p> -->
                  </div>
                  <div style="margin-top: 28px">
                    <el-button style="
                        width: 120px;
                        height: 52px;
                        line-height: 25px;
                        font-size: 16px;
                      " v-for="item in wpList" :key="item.name" :class="{ active: active == item.name }"
                      @click="selected(item.name)">{{ item.name }}</el-button>
                  </div>
                  <div style="margin-top: 36px">
                    <div style="margin-top: 8px" class="check">
                      <span class="check_font">请描述您的投诉或建议内容</span>
                    </div>
                    <div class="textarea-css">
                      <el-input :rows="8" placeholder="请输入内容" type="textarea" v-model="form.describes"></el-input>
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
        <div class="memo5">
          <div style="display: flex; justify-content: center">
            <div></div>
            <div>
              <div style="width: 1168px; height: 250px">
                <div style="margin-top: 8px; margin-top: 40px" class="check">
                  <span class="check_font">联系方式</span>
                </div>
                <!--  -->
                <div style="display: flex">
                  <div class="memo6">
                    <div style="margin-top: 8px; margin-right: 10px; width: 30px">
                      姓名
                    </div>
                    <div style="margin-right: 40px">
                      <el-input style="width: 360px" v-model="form.name" placeholder="请输入姓名"></el-input>
                    </div>
                  </div>
                  <div class="memo6">
                    <div style="margin-top: 8px; margin-right: 10px; width: 30px">
                      电话
                    </div>
                    <div style="margin-right: 40px">
                      <el-input style="width: 360px" v-model="form.phone" placeholder="请输入电话"></el-input>
                    </div>
                  </div>
                  <!-- <div class="memo6">
                    <div
                      style="margin-top: 8px; margin-right: 10px; width: 50px"
                    >
                      验证码
                    </div>
                    <div style="margin-right: 40px; display: flex">
                      <div>
                        <el-input
                          style="width: 260px"
                          v-model="form.code"
                          placeholder="请输入验证码"
                        ></el-input>
                      </div>
                      <div class="code-css" @click="clickImg">
                        <img style="width: 125px" :src="imgcode" alt="" />
                      </div>
                    </div>
                  </div> -->
                </div>
                <div style="
                    display: flex;
                    justify-content: center;
                    margin-top: 55px;
                  ">
                  <el-button style="
                      width: 120px;
                      height: 46px;
                      background-color: #19be6b !important;
                      color: #fff !important;
                      border: 0 !important;
                    " :loading="butLoading" @click="submit">提交</el-button>
                </div>
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </Content>
      <!-- 尾 -->
      <Footer class="layout-footer-center">
        <div style="
            width: 100%;
            height: 100%;
            background-image: linear-gradient(#252c37, #1e252c);
          ">
          <div style="width: 100%; height: 50px"></div>
          <!-- 低 -->
          <div style="display: flex">
            <div class="Footer-text-left">拼卡卡欢迎您的加入！</div>
            <div class="Footer-text-right">
              <p class="Footer-text-title">江苏云智界科技有限公司</p>
              <!-- <p class="opt opt-let">
                <span class="title">帮助中心</span>
                <router-link class="a-link" :to="'/userGuide'">
                  用户指南
                </router-link>
              </p> -->
              <!-- <p class="opt opt-let">
                <span class="title">关于我们</span>
                <router-link class="a-link" :to="'/contactUs'">
                  联系我们
                </router-link>
              </p> -->
              <p class="opt opt-let2">
                <span style="margin-left: -1px" class="title">服务热线</span>
                <router-link class="a-link1" :to="'#'">
                  18752036980
                </router-link>
              </p>
            </div>
          </div>
          <!-- 线 -->
          <div class="Line">
            <div class="LineClik"></div>
          </div>
          <!-- 低 -->
          <div>
            <!-- <p style="line-height: 18px">
              <img src="../assets/hui.png" style="width: 18px; height: 18px; vertical-align: middle" alt="" />
              <a style="line-height: 18px; color: #ffffff"
                href="http://www.beian.gov.cn/portal/recordQuery?token=cc5dd992-aa8e-47e8-94b8-2c2e2feadf98"
                target="_blank">豫公网安备：41080039010-21001号</a>&emsp;
              <span style="color: #b4c1cd">增值电信业务经营许可证：</span>
              <a href="https://beian.miit.gov.cn/#/Integrated/index" style="line-height: 18px; color: #ffffff"
                target="_blank">豫B2-20210727</a>
            </p> -->
            <p style="padding-bottom: 20px; color: #b4c1cd">
              <!-- © Copyright 2020-2023 -->
              <span><a style="color: #ffffff" href="#">
                  江苏云智界科技有限公司
                </a></span><br />
              All Rights Reserved.
              <a style="color: #ffffff" href="https://beian.miit.gov.cn/#/Integrated/index"
                target="_blank">苏ICP备2025185234号-1</a>
            </p>
            <div>
              <div style="width: 100%; height: 10px"></div>
            </div>
          </div>
        </div>
      </Footer>
    </Layout>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value1: 0,
      height: 0,
      one: false,
      criteriaIcon: true,
      wpList: [{ name: "投诉" }, { name: "反馈" }],
      active: "投诉",
      form: {
        msgType: "",
        describes: "",
        name: "",
        phone: "",
        // code: "",
        // captchaId: "",
      },
      imgcode: "",
      butLoading:false,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.$axios({
        method: "get",
        url: "freight/common/captcha/init",
      }).then((res) => {
        // this.form.captchaId = res.data.result;
        this.imgcode =
          "http://8.131.247.41:8089/freight/common/captcha/draw/" +
          res.data.result;
      });
    },
    selected(name) {
      this.active = name;

      if (name == "建议") {
        this.form.msgType = "1";
      } else {
        this.form.msgType = "2";
      }
    },
    //刷新二维码
    clickImg() {
      this.init();
    },
    // 提交
    submit() {
      
      if (this.form.describes == "") {
        return this.$Message.warning("您还未填写内容");
      }
      if (this.form.name == "") {
        return this.$Message.warning("您还未填写姓名");
      }
      if (this.form.phone == "") {
        return this.$Message.warning("您还未填写电话");
      }
      this.$Message.success("提交成功");
      this.form.describes = "";
      this.form.name = "";
      this.form.phone = "";
      return false
      this.butLoading=true
      this.$axios({
        method: "post",
        url: "/freight/officialWebsiteData/msgConsultingSave",
        data: {
          msgType: "2",
          describes: this.form.describes,
          name: this.form.name,
          phone: this.form.phone,
        },
        transformRequest: [
          function (data) {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            ret = ret.substring(0, ret.length - 1);
            return ret;
          },
        ],
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }).then((res) => {
        this.butLoading=false
        if (res.data.code == 200) {
          this.$Message.success("操作成功");
          this.form.describes = "";
          this.form.name = "";
          this.form.phone = "";
        } else {
          this.$Message.error(res.data.message);
        }
      });
    },
  },
};
</script>
<style scoped >
.Header-img {
  background-image: url("../assets/top-banner.png");
  width: 100%;
  height: 232px;
}
.main-content {
  width: 1200px;
  position: relative;
  bottom: -60px;
  left: 320px;
  z-index: 10;
}
.title-img {
  color: #ffffff;
  font-size: 26px;
  margin-top: 48px;
  display: inline-block;
}
.memo {
  color: #ffffff;
  font-size: 16px;
  margin-top: 10px;
}
.main1 {
  background-color: #ffffff;
  padding: 52px 0;
}
.active {
  /* background: #fd7522;
  border: 1px solid #fd7522;
  color: #fff; */
  background-color: #19be6b !important;
  color: #fff !important;
  border: 0 !important;
}
.check_font {
  color: #333333;
  font-size: 16px;
}
.check :before {
  content: "*";
  display: inline-block;
  margin-right: 2px;
  line-height: 1;
  font-family: SimSun;
  font-size: 14px;
  color: #ff0000;
}
.textarea-css {
  margin-top: 10px;
}
.memo5 {
  background-color: #eee;
}
.memo6 {
  margin-top: 40px;
  display: flex;
  margin-left: 2px;
}
.memo6-Input {
  border: 0px;
  margin-top: 8px;
}
.memo6-name {
  font-size: 14px;
  color: #999999;
  position: absolute;
  top: 7px;
}
/*     000000000000000000000000 */
.ivu-layout-header {
  padding: 0 !important;
  height: 89px !important;
  background: #fff !important;
  box-shadow: 0px 3px 7px 0px rgb(0 0 0 / 19%) !important;
}
.ivu-menu-horizontal {
  height: 89px !important;
  line-height: 89px !important;
  background: #fff !important;
  box-shadow: 0px 3px 7px 0px rgb(0 0 0 / 19%) !important;
}
.layout {
  /* border: 1px solid #d7dde4; */
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  /* overflow: hidden; */
}
.ivu-layout-footer {
  padding: 0 !important;
}
.layout-logo {
  width: 100px;
  height: 30px;
  /* background: #5b6270; */
  border-radius: 3px;
  float: left;
  position: relative;
  top: 30px;
  left: 30px;
}
.layout-logo img {
  height: 44px;
  position: relative;
  top: -13px;
  left: 50px;
}

.layout-nav {
  width: 650px;
  margin: 0 auto;
  margin-right: 20px;
}
.layout-footer-center {
  text-align: center;
}

.Footer-text-left {
  font-size: 40px;
  color: #065fc3;
  display: inline-block;
  font-style: italic;
  margin-left: 23%;
  margin-top: 45px;
}
.Footer-text-right {
  width: 321px;
  display: inline-block;
  margin-left: 96px;
  /* color: #ffffff;
  position: absolute;
  top: 50%;
  transform: translateY(-50%); */
}
.Footer-text-title {
  font-size: 22px;
  margin-bottom: 10px;
  color: #fff;
}
.opt {
  line-height: 2.2;
}
.opt-let {
  margin-left: -79px;
}
.opt-let2 {
  width: 400px;
  margin-left: -59px;
  display: inline-block;
}
.title {
  font-size: 16px;
  color: #b4c1cd;
  border-right: 1px #b4c1cd solid;
  padding-right: 15px;
}
.a-link {
  font-size: 16px;
  color: #ffffff;
  margin-left: 15px;
}
.a-link1 {
  font-size: 16px;
  color: #ffffff;
  margin-left: 14px;
}
.Line {
  margin-top: 40px;
  margin-bottom: 40px;
  /* border-bottom: 1px solid #fff; */
  z-index: 9999;
}
.LineClik {
  position: relative;
  bottom: 0px;
  left: 1px;
  width: 99.5%;
  height: 1px;
  background-color: #3f4955;
}
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
  color: rgb(33, 195, 143);
  border: 0;
}
.code-css {
  margin-left: 20px;
  width: 125px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/pages/customerServiceContact.vue